<template>
    <div class="home-page info-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li @click="back"><span>{{$t('Kanji')}}</span></li>
                <li><span>{{$t('Detail')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Kanji-Title-Pic.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">かんじ</div>
                  <div class="jp">{{$t('Kanji')}} {{$t('Detail')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grammar-content">
          <div class="grammar-detail">
            <div class="detail_inner" v-if="info.id">
              <div class="m_tabpne">
                <div class="m_tabsbj js_active">
                  <div class="tabsbj_inner">
                    <div class="detail_ordersummary">
                      <div class="detail_summary">
                        <span class="image">
                          <img :src="info.word_image" :alt="getVocabularyText(0, 'vocabulary_zh')">
                          <b>{{ getVocabularyText(0, 'vocabulary_en') }}</b>
                        </span>
                        <div class="words">
                          <div class="words_inner">
                            <p>{{ getVocabularyText(0, 'vocabulary_zh') }}<span class="slash">/</span><em>{{ getVocabularyText(0, 'vocabulary_jp') }}</em></p>
                            <i><em class="cr8a570f">{{ getVocabularyText(0, 'vocabulary_yin') }}</em></i>
                            <button
                              @click="toggleVocabularyAudio(0)"
                              :class="{ 'image-grow': activeAudioIndex === 0 }"
                            >
                              <img src="../../static/images/yin2.png" alt="Play audio">
                            </button>
                            {{ getVocabularyText(0, 'vocabulary_en') }}
                            <audio
                              preload="auto"
                              :ref="'audioVocabulary0'"
                              @ended="onAudioEnded(0)"
                            >
                              <source :src="getVocabularyAudio(0)" type="audio/mp3">
                            </audio>
                          </div>
                        </div>
                      </div>
                      <div class="detail_order mt30 ac">
                        <div class="image order1">
                          <img :src="info.stroke_image_1" alt="Stroke order 1">
                        </div>
                        <div class="image order2" style="margin-top: -3px;">
                          <img :src="info.stroke_image_2" alt="Stroke order 2">
                        </div>
                      </div>
                    </div>
                    <div class="detail_anime mt20">
                      <strong>{{$t('ANIMATION')}}</strong>
                      <div class="anime por">
<!--                        <video-->
<!--                          webkit-playsinline-->
<!--                          playsinline-->
<!--                          @play="onPlay('stroke')"-->
<!--                          @pause="onPause('stroke')"-->
<!--                          @ended="onEnded('stroke')"-->
<!--                          @seeking="onSeeking"-->
<!--                          @ratechange="onRateChange"-->
<!--                          @loadeddata="onVideoLoaded('stroke')"-->
<!--                          @error="onVideoError('stroke')"-->
<!--                          ref="videoPlayer"-->
<!--                        >-->
<!--                          <source :src="info.stroke_video" type="video/mp4">-->
<!--                          <p>To play the video, you need a browser that supports video tags.</p>-->
<!--                        </video>-->
<!--                        <div-->
<!--                          class="playbutton"-->
<!--                          :style="{ display: strokeVideoPlaying ? 'none' : 'block' }"-->
<!--                          @click="playVideo('videoPlayer', 'stroke')"-->
<!--                        ></div>-->


                        <video
                          controls
                          webkit-playsinline
                          playsinline
                          ref="videoPlayer"
                        >
                          <source :src="info.stroke_video" type="video/mp4">
                          <p>To play the video, you need a browser that supports video tags.</p>
                        </video>

                      </div>
                    </div>
                    <div class="detail_memory">
                      <strong>{{$t('MEMORY_HINT')}}</strong>
                      <div class="anime por">
<!--                        <video-->
<!--                          webkit-playsinline-->
<!--                          playsinline-->
<!--                          @play="onPlay('memory')"-->
<!--                          @pause="onPause('memory')"-->
<!--                          @ended="onEnded('memory')"-->
<!--                          @seeking="onSeeking"-->
<!--                          @ratechange="onRateChange"-->
<!--                          @loadeddata="onVideoLoaded('memory')"-->
<!--                          @error="onVideoError('memory')"-->
<!--                          ref="memoryVideoPlayer"-->
<!--                        >-->
<!--                          <source :src="info.memory_hint_video" type="video/mp4">-->
<!--                          <p>To play the video, you need a browser that supports video tags.</p>-->
<!--                        </video>-->
<!--                        <div-->
<!--                          class="playbutton"-->
<!--                          :style="{ display: memoryVideoPlaying ? 'none' : 'block' }"-->
<!--                          @click="playVideo('memoryVideoPlayer', 'memory')"-->
<!--                        ></div>-->


                        <video
                          controls
                          webkit-playsinline
                          playsinline
                          ref="videoPlayer"
                        >
                          <source :src="info.memory_hint_video" type="video/mp4">
                          <p>To play the video, you need a browser that supports video tags.</p>
                        </video>
                      </div>
                    </div>
                  </div>
                  <div class="detail_ex">
                    <strong>{{$t('EXAMPLES')}}</strong>
                    <div class="ex">
                      <div class="detail" v-for="(example, index) in info.examples" :key="index">
                        <p v-html="formatExampleText(example.text_jp)"></p>
                        <p>
                          <i>{{ example.text_yin }}</i><span class="slash">/</span>
                          <br class="oo_sprev">{{ example.text_en }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="kanji-ul">
                <ul class="">
                  <li
                    class="kanji-li"
                    v-for="item in info.relate"
                    :key="item.id"
                    :class="{ 'js_active': item.id === info.id }"
                    @click="switchKanji(item.id)"
                  >
                    <img :src="item.word_image" width="60" :alt="'Kanji ' + item.id">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>
    </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'
export default {
    components:{
        Header,Dialog
    },
    data() {
      return {
        info:{},
        id:'',
        startTime: 0,
        totalWatchTime: 0,
        reportingInterval: null,
        videoElement: null,
        strokeVideoPlaying: false,
        memoryVideoPlaying: false,
        activeAudioIndex: -1
      }
    },
    mounted() {
      // document.addEventListener('visibilitychange', this.handleVisibilityChange);
      // window.addEventListener('beforeunload', this.handleBeforeUnload);
      this.videoElement = this.$refs.videoPlayer;
    },
    beforeDestroy() {
      clearInterval(this.reportingInterval);
      // document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      // window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    watch: {
      '$route'(to, from) {
        if (to.query.id !== from.query.id) {
          this.id = to.query.id;
          this.getList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      this.pauseAllVideos();
      this.pauseAllAudios();
      next();
    },
    created(){
      this.id = this.$route.query.id
      this.getList()
    },
    methods: {
      // 获取词汇文本
      getVocabularyText(index, field) {
        if (this.info.vocabularies && this.info.vocabularies[index]) {
          let text = this.info.vocabularies[index][field];
          return text ? text.replace(/;/g, '') : '';
        }
        return '';
      },

      // 获取词汇音频
      getVocabularyAudio(index) {
        if (this.info.vocabularies && this.info.vocabularies[index]) {
          return this.info.vocabularies[index].vocabulary_audio;
        }
        return '';
      },

      // 切换词汇音频播放/暂停
      toggleVocabularyAudio(index) {
        const audioRef = `audioVocabulary${index}`;
        if (this.$refs[audioRef]) {
          if (this.activeAudioIndex === index) {
            // 如果点击的是当前正在播放的音频，则暂停
            this.$refs[audioRef].pause();
            this.activeAudioIndex = -1;
          } else {
            // 暂停其他音频
            this.pauseAllAudios();
            // 播放当前音频
            this.activeAudioIndex = index;
            this.$refs[audioRef].currentTime = 0;
            this.$refs[audioRef].play().catch(e => {
              console.log("播放失败:", e);
              this.activeAudioIndex = -1;
            });
          }
        }
      },

      // 音频播放结束
      onAudioEnded(index) {
        if (this.activeAudioIndex === index) {
          this.activeAudioIndex = -1;
        }
      },

      // 格式化示例文本
      formatExampleText(text) {
        if (!text) return '';
        return text;
      },

      // 切换汉字
      switchKanji(id) {
        if (id !== this.info.id) {
          this.$router.push({path:'/KanjiDetail',query: {id: id}});
        }
      },

      pauseAllAudios() {
        Object.keys(this.$refs).forEach(ref => {
          if (ref.startsWith('audio') && this.$refs[ref].pause) {
            this.$refs[ref].pause();
            this.$refs[ref].currentTime = 0;
          }
        });
        this.activeAudioIndex = -1;
      },

      back(){
        this.$router.push({path:'/Kanji'});
      },

      getList(){
        let that = this
        let data = {
          "id": this.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/kanji/detail', data, r =>{
          that.$parent.returnCode(r, function(){
            that.$parent.loadModal(false);
            that.info = r.data;
            that.$nextTick(() => {
              that.preloadVideos();
              that.videoElement = that.$refs.videoPlayer;
            });
          })
        })
      },

      // 播放视频
      playVideo(refName, videoType) {
        const videoPlayer = this.$refs[refName];
        if (videoPlayer) {
          videoPlayer.play().then(() => {
            console.log(`${videoType} video started playing`);
          }).catch(error => {
            console.error(`Error playing ${videoType} video:`, error);
          });
        }
      },

      pauseAllVideos() {
        const videoPlayers = [this.$refs.videoPlayer, this.$refs.memoryVideoPlayer];
        videoPlayers.forEach(player => {
          if (player) {
            player.pause();
            player.currentTime = 0;
          }
        });
        this.strokeVideoPlaying = false;
        this.memoryVideoPlaying = false;
      },

      //播放时间统计
      reportWatchTime(force = false, finished = false) {
        return;
        const now = Date.now();
        let currentWatch = (now - this.startTime) / 1000;
        this.totalWatchTime += currentWatch;
        this.startTime = now;
        if (!force && currentWatch < 5) return;
        let that = this
        let ts = Date.now();
        let seconds = Math.round(this.totalWatchTime);
        let sign = that.generateSign(seconds, ts);
        let data = {
          video_id: this.id,
          seconds: seconds,
          finished: finished,
          video_type: 'kanji',
          ts: ts,
          sign: sign
        }
        that.$api.post('/api/watch/report_time', data, r =>{
          that.$parent.returnCode(r, function(){})
        })
      },

      generateSign(score, ts, secret = "jksdfuiAa4so") {
        const str = String(score) + String(ts) + secret
        return md5(str);
      },

      canCountTime() {
        return !document.hidden &&
          !this.videoElement.paused &&
          this.videoElement.playbackRate === 1.0;
      },

      startReporting() {
        this.startTime = Date.now();
        if (this.reportingInterval) clearInterval(this.reportingInterval);

        this.reportingInterval = setInterval(() => {
          if (this.canCountTime()) {
            this.reportWatchTime();
          }
        }, 10000);
      },

      onPlay(videoType) {
        console.log(`${videoType} 开始播放`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = true;
          this.videoElement = this.$refs.videoPlayer;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = true;
          this.videoElement = this.$refs.memoryVideoPlayer;
        }

        if (!this.videoElement) return;
        if (this.videoElement.playbackRate !== 1.0) {
          this.videoElement.pause();
          return;
        }
        this.startReporting();
      },

      onPause(videoType) {
        console.log(`${videoType} 暂停播放`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = false;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = false;
        }

        if (this.canCountTime()) {
          this.reportWatchTime();
        }
        clearInterval(this.reportingInterval);
      },

      onEnded(videoType) {
        console.log(`${videoType} 播放结束`);
        if (videoType === 'stroke') {
          this.strokeVideoPlaying = false;
        } else if (videoType === 'memory') {
          this.memoryVideoPlaying = false;
        }

        this.reportWatchTime(true, true);
        clearInterval(this.reportingInterval);
      },

      onSeeking() {
        console.log('拖动进度条');
        this.startTime = Date.now();
      },

      onRateChange() {
        console.log('倍速播放');
        if (this.videoElement.playbackRate !== 1.0) {
          this.videoElement.pause();
        }
      },

      preloadVideos() {
        const videoPlayers = [this.$refs.videoPlayer, this.$refs.memoryVideoPlayer];
        videoPlayers.forEach(player => {
          if (player) {
            player.preload = "auto";
            player.load();
          }
        });
      },

      onVideoLoaded(videoType) {
        console.log(`${videoType} video loaded`);
      },

      onVideoError(videoType) {
        console.error(`${videoType} video error`);
      },

      handleVisibilityChange() {
        if (document.hidden) {
          this.reportWatchTime(true);
          clearInterval(this.reportingInterval);
        } else if (this.videoElement && !this.videoElement.paused) {
          this.startReporting();
        }
      },

      handleBeforeUnload() {
        this.reportWatchTime(true);
      },

      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      }
    }
}
</script>

<style scoped>
.detail_inner {
  padding: 20px;
}

.m_tabpne {
  margin-bottom: 20px;
}


.detail_summary {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 300px;
  margin-bottom: 20px;
}

.detail_summary .image {
  text-align: center;
  margin-right: 20px;
}

.detail_summary .image img {
  max-width: 120px;
  height: auto;
}

.detail_summary .image b {
  display: block;
  margin: -5px 0 0;
  font-weight: 400;
}
.detail_order img{width:100%}
.words_inner {
  position: relative;
}

.words_inner button {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.words_inner button.image-grow {
  transform: scale(1.2);
}

.words_inner button img {
  width: 44px;
  height: 34px;
}

.detail_anime, .detail_memory {
  margin-bottom: 30px;
}

.detail_anime strong, .detail_memory strong, .detail_ex strong {
  display: block;
  margin-bottom: 15px;
  color: #2a2d5a;
}

.anime {
  position: relative;
  border: 2px solid #475063;
  text-align: center;
  background-color: #fff;
}

.anime video {
  width: 100%;
  //max-width: 400px;
  border-radius: 8px;
}
.detail_ex .ex {
  display: grid;
  gap: 20px;
}

.detail_ex .detail {
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #2a2d5a;
}

.detail_ex .detail p:first-child {
  margin-bottom: 8px;
}

.detail_ex .detail p:last-child {
  color: #666;
}
.detail_ex .detail p em{color:#eaba74}
.slash {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/page/KanjiDetail.vue